import { render, staticRenderFns } from "./EditManageWatcher.vue?vue&type=template&id=b57b7308&scoped=true"
import script from "./EditManageWatcher.vue?vue&type=script&lang=js"
export * from "./EditManageWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57b7308",
  null
  
)

export default component.exports